import { ERefreshPageWarning } from '@enums/refreshPageWarning';

export const refreshPageNotificationButtonTestId = 'refreshPageNotificationButtonTestId';

export const warningMessagesConfig = {
  [ERefreshPageWarning.GENERAL_SETTINGS]: 'refresh_page_after_general_settings_changed',
  [ERefreshPageWarning.TICKET_TYPES]: 'refresh_page_after_ticket_type_changed',
};
